import { addToGlobalThisRet } from "@plugins";
import tippy from "tippy.js";

function initContentTooltips(tooltipClass, options) {
    const contentTooltips = document.querySelectorAll(tooltipClass);

    if (contentTooltips) {
        contentTooltips.forEach((tooltip) => {
            let target = null;
            let content = null;

            if (tooltip.hasAttribute("data-tooltip-target")) {
                target = tooltip;
            }

            Array.from(tooltip.children).forEach((child) => {
                if (child.hasAttribute("data-tooltip-content")) {
                    content = child.innerHTML;
                }
            });

            if (!tooltip.classList.contains("tooltip-initialized")) {
                tippy(
                    target,
                    Object.assign(
                        {
                            theme: "light",
                            placement: "top",
                            arrow: true,
                            ignoreAttributes: true,
                            trigger: "mouseenter focus",
                            interactive: true,
                            interactiveBorder: -1,
                            allowHTML: true,
                            duration: [100, 100],
                            content: content,
                            appendTo: () => document.body,
                        },
                        options,
                    ),
                );

                tooltip.classList.add("tooltip-initialized");
            }
        });
    }
}

addToGlobalThisRet(initContentTooltips, "initContentTooltips");
